import React from "react";
import { Row, Col, Table, Checkbox, Button, Divider, Modal } from "antd";
import {
  FileTextOutlined,
  DollarCircleOutlined,
  BankOutlined,
  FormOutlined,
} from "@ant-design/icons";
import Esign from "../../../components/Esign";
import OnboardForm from './Onboarding_form.png'
import dayjs from "dayjs";
import FormsList from "../Components/FormsList";
import { useTranslation } from 'react-i18next';

const Summary = ({ data, esignature, setEsignature }) => {
  const [onboardModalOpen, setOnboardModalOpen] = React.useState(false);
  const { t } = useTranslation();

  // Fix: safely access data.data or data
  const safeData = data?.data || data || {};
  const I9Form = safeData["jobDetails&I9Section1"] || {};
  const W4Form = safeData.W4SectionDetails || {};
  const DirectDepositForm = safeData.bankDetails || {};
    

  const finalData = {
  ...safeData,
  signatureDetails: {
    acknowledged: true,
    signatureBase64: esignature
  }
};

   

    // Dynamically build bank account data
    const getBankAccounts = (bankObj) => {
      if (!bankObj || !bankObj.hasAccount || bankObj.hasAccount !== "yes") return [];
      const accounts = [];
      let idx = 1;
      while (bankObj[`bankName_${idx}`] || bankObj[`accountNumber_${idx}`]) {
        accounts.push({
          key: idx,
          label: `Account ${idx}`,
          data: [
            { label: "Bank Name", value: bankObj[`bankName_${idx}`] || "" },
            { label: "Type Ck or SV", value: bankObj[`accountType_${idx}`] || "" },
            { label: "Transit Number", value: bankObj[`routingNumber_${idx}`] || "" },
            { label: "Account Number", value: bankObj[`accountNumber_${idx}`] || "" },
            { label: "Amount or %", value: bankObj[`amount_${idx}`] || "" },
          ]
        });
        idx++;
      }
      return accounts;
    };

    const bankAccounts = getBankAccounts(DirectDepositForm);

  // Table data for I-9 Form
  const i9Columns = [
    { title: "Workman details", dataIndex: "label", key: "label", },
    { title: "", dataIndex: "value", key: "value" },
  ];

  const i9DataLeft = [
    { key: "1", label: t('onboarding.lastNameLabel'), value: I9Form?.lastName },
    { key: "2", label: t('onboarding.firstNameLabel'), value: I9Form?.firstName },
    { key: "3", label: t('onboarding.middleNameLabel'), value: I9Form?.middleInitial || "-" },
    { key: "4", label: t('onboarding.otherLastNamesLabel'), value: I9Form?.otherLastNames || "-" },
    { key: "5", label: t('onboarding.addressLabel'), value: I9Form?.address  },
    { key: "6", label: t('onboarding.cityLabel'), value: I9Form?.city  },
    { key: "7", label: t('onboarding.stateLabel'), value: I9Form.state  },
    { key: "8", label: t('onboarding.zipCodeLabel'), value: I9Form?.zipCode  },
    { key: "9", label: t('onboarding.apartNumberLabel'), value: I9Form?.apartmentNumber || "-" },
  ];

  // Format DOB if it's a dayjs object
  const formatDOB = dob => {
    if (!dob) return "";
    if (typeof dob === "string") return dob;
    if (typeof dob === "object" && dob.$isDayjsObject && typeof dob.format === "function") {
      return dob.format("DD-MM-YYYY");
    }
    return "";
  };

  const i9DataRight = [
    { key: "1", label: t('onboarding.emailLabel'), value: I9Form?.email  },
    { key: "2", label: t('onboarding.mobileLabel'), value: I9Form?.mobile  },
    { key: "3", label: t('onboarding.dobLabel'), value: formatDOB(I9Form?.dob) },
    { key: "4", label: t('onboarding.ssn'), value: I9Form?.ssnNumber  },
    { key: "5", label: t('onboarding.citizenshipStatusLabel'), value: I9Form?.citizenshipStatus  },
  ];

  // Table data for W-4 Form
  const w4Columns = [
    { title: t('onboarding.details'), dataIndex: "label", key: "label" },
    { title: "", dataIndex: "value", key: "value" },
  ];

  const w4Data = [
    { key: "1", label: t('onboarding.filingStatusQuestionSummary'), value: W4Form?.filingStatus || "" },
    { key: "2", label: t('onboarding.taxCreditLabelSummary'), value: W4Form?.step3 },
    { key: "3", label: t('onboarding.otherIncomeLabelSummary'), value: W4Form?.step4a },
    { key: "4", label: t('onboarding.totalDeductionsLabelSummary'), value: W4Form?.step4b },
    { key: "5", label: t('onboarding.extraWithholdingLabelSummary'), value: W4Form?.step4c },
  ];

  // Table data for Direct Deposit
  const bankColumns = [
    { title: t('onboarding.accountType'), dataIndex: "label", key: "label" },
    { title: "", dataIndex: "value", key: "value" },
  ];

  const bankData = [
    { key: "1", label: t('onboarding.bankName'), value: DirectDepositForm?.bankName_1 || "" },
    { key: "2", label: t('onboarding.accountType'), value: DirectDepositForm?.accountType_1 || "" },
    { key: "3", label: t('onboarding.routingNumber'), value: DirectDepositForm?.routingNumber_1 || "" },
    { key: "4", label: t('onboarding.accountNumber'), value: DirectDepositForm?.accountNumber_1 || "" },
    { key: "5", label: t('onboarding.amountOrPercent'), value: DirectDepositForm?.amount_1 || "" },
  ];

  return (
    <div >
      {/* I-9 Form */}
      <Divider orientation="left">
         I-9 Form
      </Divider>
      <Row gutter={24} >
        <Col span={12} >
          <Table
            columns={i9Columns}
            dataSource={i9DataLeft}
            size="small"
            pagination={false}
                      bordered
                    
          />
        </Col>
        <Col span={12}>
          <Table
            columns={i9Columns}
            dataSource={i9DataRight}
            size="small"
            pagination={false}
            bordered
          />
        </Col>
      </Row>

      {/* W-4 Form */}
      <Divider orientation="left">
         W-4 Form
      </Divider>
      <Row gutter={24} >
        <Col span={12}>
          <Table
            columns={w4Columns}
            dataSource={w4Data}
            size="small"
            pagination={false}
            bordered
          />
        </Col>
        {/* <Col span={12}>
          <Table
            columns={[
              { title: "Forms", dat
               aIndex: "form", key: "form" },
              { title: "", dataIndex: "view", key: "view" },
            ]}
            dataSource={[
              { key: "1", form: "W-4 Form", view: <a>view</a> },
              { key: "2", form: "Employee Right and Responsibilities", view: <a>view</a> },
              { key: "3", form: "I-9 Form", view: <a>view</a> },
              { key: "4", form: "Direct Deposit Form", view: <a>view</a> },
            ]}
            size="small"
            pagination={false}
            bordered
          />
        </Col> */}

              <div style={{ width: '50%' }}>
          <FormsList data={finalData} />
        </div>
      </Row>

      {/* Direct Deposit */}
      <Divider orientation="left">
         Direct Deposit Details
      </Divider>
      {bankAccounts.length === 0 && (
        <div style={{ marginBottom: 16 }}>No bank account details provided.</div>
      )}
      {bankAccounts.map(acc => (
        <div key={acc.key} style={{ marginBottom: 16, }}>
          <strong>{acc.label}</strong>
          <Table
            columns={[
              { title: acc.label, dataIndex: "label", key: "label" },
              { title: "", dataIndex: "value", key: "value" }
            ]}
            dataSource={acc.data}
            size="small"
            pagination={false}
            bordered
          />
        </div>
      ))}




      {/* Acknowledge + E-Sign */}
      <Checkbox style={{ marginBottom: 16 }}>
{t("onboarding.acknowledgeCheckbox")}        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            setOnboardModalOpen(true);
          }}
        >
          Click here to View
        </a>
      </Checkbox>
      <Modal
        open={onboardModalOpen}
        onCancel={() => setOnboardModalOpen(false)}
        footer={null}
        width={900}
        bodyStyle={{ padding: 0, textAlign: "center" }}
        centered
      >
        <img
          src={OnboardForm}
          alt="Onboarding Form"
          style={{ maxWidth: "100%", borderRadius: 8, margin: 0 }}
        />
      </Modal>
      <br />
      <div style={{ marginTop: 24 }}>
        <Esign
          esignature={esignature}
          setEsignature={setEsignature}
          label={t('eSignature.supervisorESignature')}
          updateText={t('eSignature.updateESign')}
          provideText={t('eSignature.provideESign')}
          adoptText={t('eSignature.adoptYourSignature')}
          adoptAndSignText={t('eSignature.adoptAndSign')}
          clearText={t('eSignature.clear')}
          agreementText={t('eSignature.agreementText')}
        />
      </div>

      
    </div>
  );
};

export default Summary;
